module.exports = __webpack_public_path__ + "img/signal_cellular_2_bar-black.697e7b2d.svg";